// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");

function toString(v) {
  if (v === "PNG") {
    return "image/png";
  } else if (v === "JPEG") {
    return "image/jpeg";
  } else if (v === "WEBP") {
    return "image/webp";
  } else {
    return "image/gif";
  }
}

let ImageMimeType = {
  toString: toString
};

function SelectProfilePhotoButton(props) {
  let onSelectProfilePhoto = props.onSelectProfilePhoto;
  let inputEl = React.useRef(null);
  let onChange = event => {
    let eventTarget = event.target;
    let files = eventTarget.files;
    let file = files[0];
    if (file !== undefined) {
      onSelectProfilePhoto(Primitive_option.valFromOption(file));
    }
    eventTarget.value = "";
  };
  let onClick = evt => {
    evt.preventDefault();
    let node = inputEl.current;
    if (!(node == null)) {
      return node.click();
    }
  };
  let accept = Belt_Array.joinWith(props.acceptedImageTypes, ",", toString);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("input", {
        ref: Primitive_option.some(inputEl),
        style: {
          height: "0",
          left: "-9999px",
          position: "absolute",
          visibility: "hidden",
          width: "0"
        },
        accept: accept,
        multiple: false,
        type: "file",
        onChange: onChange
      }),
      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: onClick,
        size: "small",
        children: props.children
      })
    ]
  });
}

let make = SelectProfilePhotoButton;

exports.ImageMimeType = ImageMimeType;
exports.make = make;
/* react Not a pure module */
